import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Chip from "@material-ui/core/Chip";
import Box from "@material-ui/core/Box";
import Alert from "@material-ui/lab/Alert";
import InfoIcon from "@material-ui/icons/Info";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import SendIcon from "@material-ui/icons/Send";
import MessageIcon from "@material-ui/icons/Message";
import AttachFileIcon from "@material-ui/icons/AttachFile";

import { i18n } from "../../translate/i18n";
import { Button, CircularProgress, Grid, TextField, Typography } from "@material-ui/core";
// ✅ REMOVIDO: Formik ya no se usa después de la solución con useState
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import axios from "axios";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  // ✅ CORREGIDO: MainPaper dinámico según tema
  mainPaper: {
    flex: 1,
    padding: theme.spacing(3),
    paddingBottom: 100,
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#f8f9fa',
    borderRadius: '12px',
    boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
  },
  // ✅ CORREGIDO: MainHeader dinámico según tema
  mainHeader: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  // ✅ CORREGIDO: SectionCard dinámico según tema
  sectionCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: theme.mode === 'dark' ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e1e5e9'}`,
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: SectionHeader dinámico según tema
  sectionHeader: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '12px 12px 0 0'
  },
  formContainer: {
    maxWidth: 500,
    padding: theme.spacing(2)
  },
  textRight: {
    textAlign: "right"
  },
  // ✅ CORREGIDO: InfoBox dinámico según tema
  infoBox: {
    backgroundColor: theme.mode === 'dark' ? '#1e3a5f' : '#e8f4fd',
    border: `1px solid ${theme.mode === 'dark' ? '#2d4f7a' : '#bee5eb'}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.mode === 'dark' ? theme.palette.primary.light : '#1976d2',
  },
  // ✅ CORREGIDO: FileUploadArea dinámico según tema
  fileUploadArea: {
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 8,
    padding: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    color: theme.palette.text.primary,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e3f2fd',
      borderColor: theme.palette.primary.dark || '#2980b9'
    }
  },
  // ✅ CORREGIDO: FileInfo dinámico según tema
  fileInfo: {
    marginTop: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary || theme.palette.text.primary,
  },
  // ✅ CORREGIDO: EndpointBox dinámico según tema
  endpointBox: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#2c3e50',
    color: 'white',
    padding: theme.spacing(1),
    borderRadius: 4,
    fontFamily: 'monospace',
    fontSize: '0.875rem',
    margin: theme.spacing(1, 0)
  },
  limitChip: {
    backgroundColor: '#27ae60',
    color: 'white',
    fontWeight: 'bold'
  },
  methodChip: {
    backgroundColor: '#e74c3c',
    color: 'white',
    fontWeight: 'bold'
  },
  headerChip: {
    backgroundColor: '#9b59b6',
    color: 'white',
    fontWeight: 'bold'
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  buttonProgress: {
    color: theme.palette.success.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  btnWrapper: {
    position: "relative",
  },
}));

const MessagesAPI = () => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const companyId = user?.companyId;

  // ✅ REMOVIDO: Variables de estado que ya no se usan después de la solución con useState
  const [file, setFile] = useState({})
  const [selectedFileName, setSelectedFileName] = useState('')
  
  // ✅ SOLUCIÓN RADICAL: Estados separados para formulario de texto
  const [textToken, setTextToken] = useState('')
  const [textNumber, setTextNumber] = useState('')
  const [textBody, setTextBody] = useState('')
  const [isSubmittingText, setIsSubmittingText] = useState(false)
  
  // ✅ SOLUCIÓN RADICAL: Estados separados para formulario multimedia
  const [mediaToken, setMediaToken] = useState('')
  const [mediaNumber, setMediaNumber] = useState('')
  const [mediaBody, setMediaBody] = useState('')
  const [isSubmittingMedia, setIsSubmittingMedia] = useState(false)
  
  // ✅ SECCIÓN 3: Estados para formulario de grupos
  const [groupToken, setGroupToken] = useState('')
  const [groupId, setGroupId] = useState('')
  const [groupBody, setGroupBody] = useState('')
  const [isSubmittingGroup, setIsSubmittingGroup] = useState(false)
  
  // ✅ SECCIÓN 4: Estados para envío multimedia a grupos
  const [groupMediaToken, setGroupMediaToken] = useState('')
  const [groupMediaId, setGroupMediaId] = useState('')
  const [groupMediaBody, setGroupMediaBody] = useState('')
  const [groupMediaFile, setGroupMediaFile] = useState({})
  const [groupMediaFileName, setGroupMediaFileName] = useState('')
  const [isSubmittingGroupMedia, setIsSubmittingGroupMedia] = useState(false)

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      if (companyId) {
        const planConfigs = await getPlanCompany(undefined, companyId);
        if (!planConfigs.plan.useExternalApi) {
          toast.error(i18n.t("messagesAPI.messages.noPermission"));
          setTimeout(() => {
            history.push(`/`)
          }, 1000);
        }
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getEndpoint = () => {
    const backendUrl = (typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';
    if (!backendUrl) {
      throw new Error('REACT_APP_BACKEND_URL no está configurado');
    }
    return backendUrl + '/api/messages/send'
  }

  // ✅ SOLUCIÓN RADICAL: Función simplificada para mensajes de texto
  const handleSendTextMessageSimple = async () => {
    const data = { number: textNumber, body: textBody };
    
    // ✅ DEBUG: Log de la petición que se va a enviar
    console.log('🔍 DEBUG Frontend Simple - URL:', getEndpoint());
    console.log('🔍 DEBUG Frontend Simple - Data:', data);
    console.log('🔍 DEBUG Frontend Simple - Token:', textToken);
    console.log('🔍 DEBUG Frontend Simple - Token length:', textToken ? textToken.length : 'UNDEFINED');
    
    setIsSubmittingText(true);
    
    try {
      const response = await axios.request({
        url: getEndpoint(),
        method: 'POST',
        data,
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${textToken}`
        }
      })
      
      console.log('✅ DEBUG Frontend Simple - Response:', response.data);
      toast.success("Mensaje enviado exitosamente");
      
      // Limpiar formulario
      setTextToken('');
      setTextNumber('');
      setTextBody('');
      
    } catch (err) {
      console.log('❌ DEBUG Frontend Simple - Error:', err.response?.data || err.message);
      toastError(err);
    } finally {
      setIsSubmittingText(false);
    }
  }

  // ✅ REMOVIDO: Función que ya no se usa después de la solución con useState

  // ✅ SOLUCIÓN RADICAL: Función simplificada para mensajes multimedia
  const handleSendMediaMessageSimple = async () => {
    try {
      const firstFile = file[0];
      const data = new FormData();
      data.append('number', mediaNumber);
      data.append('medias', firstFile);
      
      // ✅ MEJORA: Agregar mensaje opcional si está presente
      if (mediaBody && mediaBody.trim()) {
        data.append('body', mediaBody.trim());
        console.log('🔍 DEBUG Frontend Media Simple - Mensaje incluido:', mediaBody);
      } else {
        console.log('🔍 DEBUG Frontend Media Simple - Sin mensaje adicional');
      }
      
      console.log('🔍 DEBUG Frontend Media Simple - File:', firstFile.name, 'Size:', firstFile.size);
      console.log('🔍 DEBUG Frontend Media Simple - Token:', mediaToken);
      console.log('🔍 DEBUG Frontend Media Simple - Token length:', mediaToken ? mediaToken.length : 'UNDEFINED');
      
      setIsSubmittingMedia(true);
      
      await axios.request({
        url: getEndpoint(),
        method: 'POST',
        data,
        headers: {
          'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${mediaToken}`
        }
      })
      
      toast.success("Mensaje multimedia enviado exitosamente");
      
      // Limpiar formulario
      setMediaToken('');
      setMediaNumber('');
      setMediaBody('');
      setFile({});
      setSelectedFileName('');
      document.getElementById('medias').files = null;
      document.getElementById('medias').value = null;
      
    } catch (err) {
      console.log('❌ DEBUG Frontend Media Simple - Error:', err.response?.data || err.message);
      toastError(err);
    } finally {
      setIsSubmittingMedia(false);
    }
  }

  // ✅ REMOVIDO: Función que ya no se usa después de la solución con useState

  const handleFileChange = (e) => {
    const files = e.target.files;
    setFile(files);
    if (files && files[0]) {
      setSelectedFileName(files[0].name);
    } else {
      setSelectedFileName('');
    }
  }

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // ✅ SECCIÓN 3: Función para enviar mensajes a grupos
  const handleSendGroupMessage = async () => {
    const whatsappId = 1; // TODO: Obtener del estado de WhatsApps
    
    // Construir URL correctamente - usar REACT_APP_BACKEND_URL directamente
    const backendUrl = (typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';
    const url = `${backendUrl}/api/messages/send-group/${whatsappId}`;
    
    const data = { 
      number: groupId,
      body: groupBody
    };
    
    console.log('🔍 [GroupSend] Backend URL:', backendUrl);
    console.log('🔍 [GroupSend] Final URL:', url);
    console.log('🔍 [GroupSend] Data:', data);
    
    setIsSubmittingGroup(true);
    
    try {
      const response = await axios.post(url, data, {
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${groupToken}`
        }
      });
      
      console.log('✅ [GroupSend] Respuesta:', response.data);
      toast.success("Mensaje enviado al grupo exitosamente");
      setGroupId('');
      setGroupBody('');
    } catch (err) {
      console.error('❌ [GroupSend] Error completo:', err);
      console.error('❌ [GroupSend] Error URL intentada:', url);
      console.error('❌ [GroupSend] Error response:', err.response?.data);
      console.error('❌ [GroupSend] Error status:', err.response?.status);
      toast.error(err.response?.data?.error || "Error al enviar mensaje al grupo");
    } finally {
      setIsSubmittingGroup(false);
    }
  }

  // ✅ SECCIÓN 4: Función para enviar multimedia a grupos
  const handleSendGroupMedia = async () => {
    const whatsappId = 1;
    const backendUrl = (typeof process !== 'undefined' && process.env) ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8080';
    const url = `${backendUrl}/api/messages/send-group/${whatsappId}`;
    
    try {
      const firstFile = groupMediaFile[0];
      const data = new FormData();
      data.append('number', groupMediaId);
      data.append('medias', firstFile);
      
      // Mensaje opcional para grupos
      if (groupMediaBody && groupMediaBody.trim()) {
        data.append('body', groupMediaBody.trim());
      }
      
      console.log('🔍 [GroupMediaSend] URL:', url);
      console.log('🔍 [GroupMediaSend] File:', firstFile.name);
      
      setIsSubmittingGroupMedia(true);
      
      await axios.post(url, data, {
        headers: {
          'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${groupMediaToken}`
        }
      });
      
      console.log('✅ [GroupMediaSend] Mensaje multimedia enviado a grupo');
      toast.success("Mensaje multimedia enviado al grupo exitosamente");
      
      // Limpiar formulario
      setGroupMediaToken('');
      setGroupMediaId('');
      setGroupMediaBody('');
      setGroupMediaFile({});
      setGroupMediaFileName('');
      
    } catch (err) {
      console.error('❌ [GroupMediaSend] Error:', err);
      toast.error(err.response?.data?.error || "Error al enviar multimedia al grupo");
    } finally {
      setIsSubmittingGroupMedia(false);
    }
  }

  const handleGroupMediaFileChange = (e) => {
    const files = e.target.files;
    setGroupMediaFile(files);
    if (files && files[0]) {
      setGroupMediaFileName(files[0].name);
    } else {
      setGroupMediaFileName('');
    }
  }

  const renderFormMessageText = () => {
    return (
      <div className={classes.formContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Token registrado"
              value={textToken}
              onChange={(e) => {
                console.log('🔍 DEBUG Simple - Token cambiado:', e.target.value);
                setTextToken(e.target.value);
              }}
              autoFocus
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder="Ingresa tu token aquí"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Número"
              value={textNumber}
              onChange={(e) => setTextNumber(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder="51980795094"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Mensaje"
              value={textBody}
              onChange={(e) => setTextBody(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              multiline
              rows={3}
              className={classes.textField}
              required
              placeholder="Escribe tu mensaje aquí"
            />
          </Grid>
          <Grid item xs={12} className={classes.textRight}>
            <Button
              onClick={handleSendTextMessageSimple}
              color="primary"
              variant="contained"
              startIcon={<SendIcon />}
              className={classes.btnWrapper}
              disabled={isSubmittingText || !textToken || !textNumber || !textBody}
            >
              {isSubmittingText ? (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              ) : 'Enviar Mensaje'}
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }

  const renderFormMessageMedia = () => {
    return (
      <div className={classes.formContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Token registrado"
              value={mediaToken}
              onChange={(e) => {
                console.log('🔍 DEBUG Media Simple - Token cambiado:', e.target.value);
                setMediaToken(e.target.value);
              }}
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder="Ingresa tu token aquí"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Número"
              value={mediaNumber}
              onChange={(e) => setMediaNumber(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              className={classes.textField}
              required
              placeholder="51980795094"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Mensaje (Opcional)"
              value={mediaBody}
              onChange={(e) => setMediaBody(e.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              multiline
              rows={2}
              className={classes.textField}
              placeholder="Escribe un mensaje opcional para acompañar el archivo..."
            />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.fileUploadArea} onClick={() => document.getElementById('medias').click()}>
              <CloudUploadIcon style={{ fontSize: 48, color: theme.palette.primary.main, marginBottom: 16 }} />
              <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary }}>
                {selectedFileName ? selectedFileName : 'Seleccionar Archivo'}
              </Typography>
              <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                Haz clic para seleccionar un archivo multimedia
              </Typography>
              {file[0] && (
                <div className={classes.fileInfo}>
                  <strong>Tamaño:</strong> {formatFileSize(file[0].size)}
                </div>
              )}
              <input 
                type="file" 
                name="medias" 
                id="medias" 
                required 
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
              />
            </div>
          </Grid>
          <Grid item xs={12} className={classes.textRight}>
            <Button
              onClick={handleSendMediaMessageSimple}
              color="primary"
              variant="contained"
              startIcon={<AttachFileIcon />}
              className={classes.btnWrapper}
              disabled={isSubmittingMedia || !mediaToken || !mediaNumber || !file[0]}
            >
              {isSubmittingMedia ? (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              ) : 'Enviar Multimedia'}
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }

  return (
    <Paper className={classes.mainPaper} variant="outlined">
      <Typography variant="h4" className={classes.mainHeader}>
        <MessageIcon style={{ marginRight: 16, verticalAlign: 'middle' }} />
        API de Mensajería WhatsApp
      </Typography>

      {/* Información General */}
      <Alert severity="info" className={classes.elementMargin}>
        <Typography variant="h6" gutterBottom>
          <InfoIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
          Información Importante
        </Typography>
        <ul>
          <li><strong>Token requerido:</strong> Debes registrar un token vinculado a la conexión que enviará los mensajes</li>
          <li><strong>Formato del número:</strong> Código de país + DDD + número (sin caracteres especiales)</li>
          <li><strong>Ejemplo:</strong> 51959858768 (Perú: 51, DDD: 959, Número: 858768)</li>
        </ul>
      </Alert>

      {/* Sección 1: Mensajes de Texto */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <MessageIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">1. Mensajes de Texto</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Información de la API
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>Envía mensajes de texto simples a través de WhatsApp Business API.</p>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="ENDPOINT" className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint()}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="MÉTODO" className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="HEADERS" className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>Authorization (Bearer token) y Content-Type (application/json)</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>Body (JSON):</strong>
                </Typography>
                <div className={classes.endpointBox}>
                  {`{ "number": "51959858768", "body": "Su mensaje" }`}
                </div>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Prueba de Envío
              </Typography>
              {renderFormMessageText()}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 2: Mensajes Multimedia */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <AttachFileIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">2. Mensajes Multimedia</Typography>
              <Chip label="HASTA 100MB" className={classes.limitChip} style={{ marginLeft: 16 }} />
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Información de la API
              </Typography>
              <Typography component="div">
                <p>Envía archivos multimedia (imágenes, videos, documentos, audio) a través de WhatsApp Business API.</p>
                
                <Alert severity="success" style={{ marginBottom: 16 }}>
                  <strong><span role="img" aria-label="checkmark">✅</span> Capacidad máxima:</strong> Archivos de hasta <strong>100 MB</strong>
                </Alert>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="ENDPOINT" className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint()}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="MÉTODO" className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="HEADERS" className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8 }}>Authorization (Bearer token) y Content-Type (multipart/form-data)</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>FormData:</strong>
                </Typography>
                <ul>
                  <li><strong>number:</strong> 51959858768</li>
                  <li><strong>medias:</strong> archivo</li>
                  <li><strong>body:</strong> mensaje opcional (texto acompañante)</li>
                </ul>
                
                <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16, color: theme.palette.text.primary }}>
                  <strong>Tipos de archivo soportados:</strong>
                </Typography>
                <ul>
                  <li><strong>Imágenes:</strong> JPG, PNG, GIF (hasta 5MB)</li>
                  <li><strong>Videos:</strong> MP4, AVI, MOV (hasta 16MB)</li>
                  <li><strong>Documentos:</strong> PDF, DOC, XLS, PPT (hasta 100MB)</li>
                  <li><strong>Audio:</strong> MP3, WAV, OGG (hasta 16MB)</li>
                </ul>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Prueba de Envío
              </Typography>
              {renderFormMessageMedia()}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 3: Mensajes a Grupos */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <MessageIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">3. Mensajes a Grupos de WhatsApp</Typography>
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Información de la API
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>Envía mensajes de texto a grupos de WhatsApp a través de la API.</p>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="ENDPOINT" className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint() + '/send-group/:whatsappId'}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="MÉTODO" className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="HEADERS" className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>Authorization (Bearer token) y Content-Type (application/json)</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>Body (JSON):</strong>
                </Typography>
                <div className={classes.endpointBox}>
                  {`{ "number": "12036312345678901234", "body": "Su mensaje" }`}
                </div>

                <Alert severity="warning" style={{ marginTop: 16 }}>
                  <strong><span role="img" aria-label="warning">⚠️</span> Nota:</strong> El sistema automáticamente agregará el sufijo <strong>@g.us</strong> al ID del grupo
                </Alert>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Prueba de Envío
              </Typography>
              <div className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Token registrado *"
                      value={groupToken}
                      onChange={(e) => setGroupToken(e.target.value)}
                      autoFocus
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder="Ingresa tu token aquí"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="ID del Grupo *"
                      value={groupId}
                      onChange={(e) => setGroupId(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder="12036312345678901234"
                      helperText="ID del grupo sin @g.us (ej: 12036312345678901234)"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Mensaje *"
                      value={groupBody}
                      onChange={(e) => setGroupBody(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      multiline
                      rows={3}
                      required
                      placeholder="Escribe tu mensaje aquí"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.textRight}>
                    <Button
                      onClick={handleSendGroupMessage}
                      color="primary"
                      variant="contained"
                      startIcon={<SendIcon />}
                      className={classes.btnWrapper}
                      disabled={isSubmittingGroup || !groupToken || !groupId || !groupBody}
                    >
                      {isSubmittingGroup ? (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      ) : 'Enviar a Grupo'}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Sección 4: Mensajes Multimedia a Grupos */}
      <Card className={classes.sectionCard}>
        <CardHeader 
          className={classes.sectionHeader}
          title={
            <Box display="flex" alignItems="center">
              <AttachFileIcon style={{ marginRight: 8 }} />
              <Typography variant="h6">4. Mensajes Multimedia a Grupos</Typography>
              <Chip label="HASTA 100MB" className={classes.limitChip} style={{ marginLeft: 16 }} />
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Información de la API
              </Typography>
              <Typography component="div" style={{ color: theme.palette.text.primary }}>
                <p>Envía archivos multimedia (imágenes, videos, documentos, audio) a grupos de WhatsApp a través de la API.</p>
                
                <Alert severity="success" style={{ marginBottom: 16 }}>
                  <strong><span role="img" aria-label="checkmark">✅</span> Capacidad máxima:</strong> Archivos de hasta <strong>100 MB</strong>
                </Alert>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="ENDPOINT" className={classes.endpointBox} />
                </Box>
                <div className={classes.endpointBox}>
                  {getEndpoint() + '/send-group/:whatsappId'}
                </div>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="MÉTODO" className={classes.methodChip} />
                  <Typography style={{ marginLeft: 8, color: theme.palette.text.primary }}>POST</Typography>
                </Box>
                
                <Box display="flex" alignItems="center" marginY={1}>
                  <Chip label="HEADERS" className={classes.headerChip} />
                  <Typography style={{ marginLeft: 8 }}>Authorization (Bearer token) y Content-Type (multipart/form-data)</Typography>
                </Box>
                
                <Typography variant="subtitle2" gutterBottom style={{ color: theme.palette.text.primary }}>
                  <strong>FormData:</strong>
                </Typography>
                <ul>
                  <li><strong>number:</strong> ID del grupo (ej: 12036312345678901234)</li>
                  <li><strong>medias:</strong> archivo multimedia</li>
                  <li><strong>body:</strong> mensaje opcional (texto acompañante)</li>
                </ul>
                
                <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16, color: theme.palette.text.primary }}>
                  <strong>Tipos de archivo soportados:</strong>
                </Typography>
                <ul>
                  <li><strong>Imágenes:</strong> JPG, PNG, GIF (hasta 5MB)</li>
                  <li><strong>Videos:</strong> MP4, AVI, MOV (hasta 16MB)</li>
                  <li><strong>Documentos:</strong> PDF, DOC, XLS, PPT (hasta 100MB)</li>
                  <li><strong>Audio:</strong> MP3, WAV, OGG (hasta 16MB)</li>
                </ul>

                <Alert severity="warning" style={{ marginTop: 16 }}>
                  <strong><span role="img" aria-label="warning">⚠️</span> Nota:</strong> El sistema automáticamente agregará el sufijo <strong>@g.us</strong> al ID del grupo
                </Alert>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom color="primary">
                Prueba de Envío
              </Typography>
              <div className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Token registrado *"
                      value={groupMediaToken}
                      onChange={(e) => setGroupMediaToken(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder="Ingresa tu token aquí"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="ID del Grupo *"
                      value={groupMediaId}
                      onChange={(e) => setGroupMediaId(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      required
                      placeholder="12036312345678901234"
                      helperText="ID del grupo sin @g.us"
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Mensaje (Opcional)"
                      value={groupMediaBody}
                      onChange={(e) => setGroupMediaBody(e.target.value)}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      multiline
                      rows={2}
                      placeholder="Escribe un mensaje opcional para acompañar el archivo..."
                      className={classes.textField}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <div className={classes.fileUploadArea} onClick={() => document.getElementById('groupMedias').click()}>
                      <CloudUploadIcon style={{ fontSize: 48, color: theme.palette.primary.main, marginBottom: 16 }} />
                      <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary }}>
                        {groupMediaFileName ? groupMediaFileName : 'Seleccionar Archivo'}
                      </Typography>
                      <Typography variant="body2" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                        Haz clic para seleccionar un archivo multimedia
                      </Typography>
                      {groupMediaFile[0] && (
                        <div className={classes.fileInfo}>
                          <strong>Tamaño:</strong> {formatFileSize(groupMediaFile[0].size)}
                        </div>
                      )}
                      <input 
                        type="file" 
                        name="medias" 
                        id="groupMedias" 
                        required 
                        onChange={handleGroupMediaFileChange}
                        style={{ display: 'none' }}
                        accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} className={classes.textRight}>
                    <Button
                      onClick={handleSendGroupMedia}
                      color="primary"
                      variant="contained"
                      startIcon={<AttachFileIcon />}
                      className={classes.btnWrapper}
                      disabled={isSubmittingGroupMedia || !groupMediaToken || !groupMediaId || !groupMediaFile[0]}
                    >
                      {isSubmittingGroupMedia ? (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      ) : 'Enviar Multimedia a Grupo'}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default MessagesAPI;